import { useAppSelector } from 'flow/hooks/useRedux';

interface SinglePaneModeHook {
    isSinglePaneMode: boolean;
}

const useSinglePaneMode = (): SinglePaneModeHook => {
    const isSinglePaneMode =
        useAppSelector((state) => state.app.get('layoutColumns')) === 1;

    return { isSinglePaneMode };
};

export default useSinglePaneMode;
